import React from 'react'
import Confirmation, { WebLink } from '../../components/Confirmation'

export default class Profile extends React.Component {
  render () {
    return (
      <Confirmation
        title="Pay your Boost Membership"
        h1="Success!"
        p="You have payed your Boost membership."
      >
        <WebLink to="/profile/dashboard">Go to your Dashboard ›</WebLink>
      </Confirmation>
    )
  }
}
